export const GET_donation = ({ donation }) => donation;
